import { RootState } from '../redux';

export const selectEntitiesCompletionStatus = (state: RootState) => state.entitiesCompletionStatus;
